module.exports = __webpack_public_path__ + "img/koudan.e4533ec9.png";